import React from 'react';
import { createPortal } from 'react-dom';

export interface DropdownPosition {
  top: number;
  left: number;
}

interface AccountsActionDropdownProps {
  children: React.ReactNode;
  open: boolean;
  position: DropdownPosition | null;
  widthClass?: string;
}

export const getDropdownPosition = (
  triggerEl: HTMLElement,
  menuWidth = 176,
): DropdownPosition => {
  const rect = triggerEl.getBoundingClientRect();
  const viewportPadding = 8;

  return {
    top: rect.bottom + 4,
    left: Math.min(
      Math.max(viewportPadding, rect.right - menuWidth),
      window.innerWidth - menuWidth - viewportPadding,
    ),
  };
};

export function AccountsActionDropdown({
  children,
  open,
  position,
  widthClass = 'w-44',
}: AccountsActionDropdownProps) {
  if (!open || !position || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div
      className={`fixed ${widthClass} rounded-xl border border-slate-100 bg-white py-1.5 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.1)] z-[9999] animate-in fade-in zoom-in-95 duration-100`}
      style={{ top: position.top, left: position.left }}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>,
    document.body,
  );
}
